<sw-page class="topdata-es-synonym-list-page">
    <template #search-bar>
        <sw-search-bar
            initial-search-type="tdes_synonym"
            :initial-search="term"
            @search="onSearch"
        />
    </template>

    <template #smart-bar-header>
        <h2>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-single-select
            v-model:value="filterScope"
            :options="scopeOptions"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.filterScopePlaceholder')"
            class="topdata-es-synonym-scope-filter"
            :show-clearable="true"
            @update:value="onFilterChange"
        />

        <sw-single-select
            v-model:value="filterSource"
            :options="sourceOptions"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.filterSourcePlaceholder')"
            class="topdata-es-synonym-source-filter"
            :show-clearable="true"
            @update:value="onFilterChange"
        />

        <sw-single-select
            v-model:value="filterLanguage"
            :options="languageOptions"
            :placeholder="$tc('TopdataEnhancedSearchSW6.topdata-es-synonym.filterLanguagePlaceholder')"
            class="topdata-es-synonym-language-filter"
            :show-clearable="true"
            @update:value="onFilterChange"
        />

        <sw-button variant="primary" @click="onDownloadCsv">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.buttonDownloadCsv') }}
        </sw-button>
        <sw-button variant="primary" @click="onAddSynonym">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.buttonAdd') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-es-synonym"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-scope="{ item }">
                <sw-label v-if="item.scope === 'GLOBAL'" variant="neutral" size="medium">
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeBoth') }}
                </sw-label>
                <sw-label v-else-if="item.scope === 'PRODUCT'" variant="info" size="medium">
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeProduct') }}
                </sw-label>
                <sw-label v-else-if="item.scope === 'CATEGORY'" variant="success" size="medium">
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym.scopeCategory') }}
                </sw-label>
            </template>

            <template #column-languageId="{ item }">
                <sw-label :variant="item.languageId ? 'default' : 'neutral'" size="small">
                    {{ getLanguageLabel(item.languageId) }}
                </sw-label>
            </template>

            <template #column-source="{ item }">
                <sw-label :variant="getSourceVariant(item.source)" size="small">
                    {{ getSourceLabel(item.source) }}
                </sw-label>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago :date="item.createdAt" :date-time-format="{ month: '2-digit', day: '2-digit' }" />
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onEditSynonym(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onShowDeleteModal(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-confirm-modal
            v-if="showDeleteModal"
            :title="$tc('global.default.delete')"
            :text="deleteConfirmText"
            :confirmButtonVariant="'danger'"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />

        <topdata-es-synonym-form
            v-if="activeModal"
            :entity="currentEntity"
            :repository="repository"
            @save="onCloseModal"
            @cancel="onCloseModal"
        />
    </template>
</sw-page>
